'use strict';

var XMLHttpRequest = require('xmlhttprequest').XMLHttpRequest;

module.exports = XMLHttpRequest;


//////////////////
// WEBPACK FOOTER
// ./~/ipfs-mini/lib/lib/XMLHttpRequest.js
// module id = 890
// module chunks = 0